import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { alTeal } from '@reward-platform/lift/theme/aer_lingus/variables'

export const helpers = createMultiStyleConfigHelpers([
  'textBaseStyle',
  'balanceBoosterAppliedStyle',
])

const sharedTextStyles = {
  lineHeight: 1,
  display: 'inline-block',
  fontWeight: 'semibold',
  fontSize: 'sm',
  borderRadius: 'lg',
  p: {
    base: 2,
  },
  border: {
    lg: 'var(--alto-sem-border-width-sm) solid var(--alto-sem-color-brand-secondary)',
    base: 'var(--alto-sem-border-width-sm) solid white',
  },
}

export const PriceBreakdownCollectedAviosAmount = helpers.defineMultiStyleConfig({
  baseStyle: helpers.definePartsStyle({
    textBaseStyle: {
      ...sharedTextStyles,
      color: { base: 'brand.white', lg: 'var(--alto-sem-color-brand-secondary)' },
      bg: 'bg.base',
    },
    balanceBoosterAppliedStyle: {
      ...sharedTextStyles,
      bg: 'bg.accent.vibrant.active',
      color: { base: 'brand.white', lg: 'var(--alto-sem-color-brand-secondary)' },
    },
  }),
})
